module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "ch019"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0046-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While Gene Roddenberry was reluctant to recycle certain iconic elements from "), _c('em', [_vm._v("The Original Series")]), _vm._v(", he saw no problem with rehiring some of the same behind-the-scenes department heads who’d been so creative the first time around. Thus, when the time came to create uniforms for his new crew, he again called on the man who’d designed the first Starfleet uniform: William Ware Theiss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the two decades since Theiss had collaborated with Roddenberry, he’d worked steadily as a costume designer, on cult favorites like "), _c('em', [_vm._v("Harold and Maude")]), _vm._v(", "), _c('em', [_vm._v("Bound for Glory")]), _vm._v(", "), _c('em', [_vm._v("Goin’ South")]), _vm._v(", and "), _c('em', [_vm._v("Heart Like a Wheel")]), _vm._v(", and most recently on a series of TV movies for Disney. But he hadn’t lost his unique "), _c('em', [_vm._v("Star Trek")]), _vm._v(" touch, and as he set to work, he deliberately steered away from the military-inspired uniforms worn by Captain Kirk and company in the recent franchise movies. Instead, Theiss designed a variety of stylish outfits, including the unisex “skant” (skirt/pant hybrid) worn by Deanna Troi in the pilot, and periodically by background players during the first season. Eventually, the producers expressed their preference for one-piece jumpsuits, and during repeated “wardrobe meetings,” Theiss (here in a plaid shirt) brought in models to demonstrate a variety of possibilities. Roddenberry, Rick Berman, and Robert Justman chose the prototypes seen "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch019#f0046-02"
    }
  }, [_vm._v("here")]), _vm._v(". “They’re a simple, uncomplicated design,” explained Theiss. “I try not to make my designs too complex, visually.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Theiss retired from the show after only one season. He passed away in 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "f0046-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0046-02.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0047-01.jpg",
      "width": "450px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11980de0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch019.vue
// module id = 129
// module chunks = 0